import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import axios from "axios";
import { authAxios, API, useAuth } from "@/contexts/AuthContext";

const BrandingContext = createContext(null);

const DEFAULTS = {
  app_name: "WA Bot", logo_url: "", primary_color: "#0f172a",
  secondary_color: "#f1f5f9", accent_color: "#22c55e",
  login_title: "Welcome back",
  login_subtitle: "Sign in to your WhatsApp Bot Dashboard",
  sidebar_title: "WA Bot",
  dashboard_welcome_text: "Here's an overview of your WhatsApp Bot workspace",
};

export function BrandingProvider({ children }) {
  const { user } = useAuth();
  const [branding, setBranding] = useState(DEFAULTS);

  const fetchBranding = useCallback(async () => {
    try {
      if (user) {
        const { data } = await authAxios.get(`${API}/auth/branding`);
        setBranding({ ...DEFAULTS, ...data });
      } else {
        const { data } = await axios.get(`${API}/branding/public`);
        setBranding({ ...DEFAULTS, ...data });
      }
    } catch {
      setBranding(DEFAULTS);
    }
  }, [user]);

  useEffect(() => { fetchBranding(); }, [fetchBranding]);

  return (
    <BrandingContext.Provider value={{ branding, refreshBranding: fetchBranding }}>
      {children}
    </BrandingContext.Provider>
  );
}

export function useBranding() {
  const ctx = useContext(BrandingContext);
  return ctx || { branding: DEFAULTS, refreshBranding: () => {} };
}
